import React, {useMemo} from 'react';
import {ProductContextProvider} from 'contexts/product-context';
import {useIntroHook} from 'components/products/intro/IntroHook';
import {useCalculateIntroQuery} from 'query/products/home-safe/intro';
import {useIntroOverallResults} from 'components/products/intro/IntroOverallResults';
import {API_ROUTES} from 'constants/illustrator';
import {useProductWithRef} from 'hooks/product-ref';

/**
 *
 * The "Intro" product, aka "HomeSafe Intro", part of the "HomeSafe" products.
 *
 */

const Intro = React.forwardRef(function TitleRender(props, ref) {
  const {product, setRef, ...rest} = props;

  const introHook = useIntroHook({product});
  const introQuery = useCalculateIntroQuery({product});
  const introOverallResults = useIntroOverallResults({product});

  const productResults = useMemo(() => ({...introOverallResults, ...introHook}), [introHook, introOverallResults]);

  useProductWithRef({
    productDetails: introHook,
    productResults: introOverallResults,
    productQuery: introQuery,
    ref,
    ApiRoute: API_ROUTES.INTRO,
  });

  return (
    <ProductContextProvider
      productDetails={introHook}
      productResults={productResults}
      productQuery={introQuery}
      product={product}
      {...rest}
    />
  );
});

export default Intro;
